// avatar.js

import request from '@/utils/request';

export function postAvatarUpload(data) {
  return request({
    url: '/v1/user_info/avatar',
    method: 'post',
    data: data,
  });
}
